import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../AppContext";

/**
 * Fetches and caches the user's subscription state from /api/billing/me.
 * Returns { sub, loading, hasAccess } where `hasAccess` is true if the
 * subscription is active OR the 14-day Pro trial is in progress.
 */
export function useSubscription() {
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/billing/me`)
      .then(({ data }) => { if (mounted) setSub(data); })
      .catch(() => { if (mounted) setSub(null); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  const hasAccess = !!(sub && (sub.active || sub.in_pro_trial));
  return { sub, loading, hasAccess };
}
